import React from 'react'
import { useSelector, useDispatch } from 'react-redux'

import { makeStyles } from '@material-ui/core/styles'
import Paper from '@material-ui/core/Paper'
import Grid from '@material-ui/core/Grid'
import Typography from '@material-ui/core/Typography'
import Button from '@material-ui/core/Button'

import FormWrapper from 'components/form/Wrapper'
import QuoteSummary from 'components/quote/Summary'

import selectors from 'store/selectors'
import routerActions from 'store/modules/router'
import quoteActions from 'store/modules/quote'
import networkActions from 'store/modules/network'

const useStyles = makeStyles(theme => ({
  root: {
    padding: theme.spacing(2),
  },
  paper: {
    padding: theme.spacing(5),
  },
  button: {
    marginRight: theme.spacing(2),
  },
}))

const QuoteDetails = ({

}) => {
  const classes = useStyles()
  const dispatch = useDispatch()

  const id = useSelector(selectors.router.idParam) || 'new'
  const quote = useSelector(selectors.quote.collection.item)
  const error = useSelector(selectors.quote.errors.save)
  const submitting = useSelector(selectors.quote.loading.save)
  const loading = useSelector(selectors.quote.loading.get)
  const schema = useSelector(selectors.quote.schema)
  const client = useSelector(selectors.quote.quoteClient)
  const project = useSelector(selectors.project.activeProject)


  const onSave = (id, data) => dispatch(quoteActions.saveDetails(id, data))
  const onCancel = () => dispatch(routerActions.navigateTo('quote.list'))
  const clearError = () => dispatch(networkActions.clearError('quote.save'))

  if(!quote && id!='new') return null

  return (
    <div className={ classes.root }>
      <Grid container spacing={3}>
        <Grid item xs={ id == 'new' ? 12 : 6 }>
          <Paper className={ classes.paper }>
            <Typography variant="h6" gutterBottom>
              Quote Details
            </Typography>
            <FormWrapper
              schema={ schema }
              initialValues={ quote }
              error={ error }
              onSubmit={ (values) => onSave(id, values) }
              renderButtons={
                ({
                  handleSubmit,
                }) => {
                  return (
                    <React.Fragment>
                      <Button
                        className={ classes.button }
                        type="button"
                        variant="contained"
                        onClick={ onCancel }
                      >
                        Cancel
                      </Button>
                      <Button
                        className={ classes.button }
                        type="button"
                        variant="contained"
                        color="primary"
                        disabled={ submitting }
                        onClick={ handleSubmit }
                      >
                        Save
                      </Button>
                    </React.Fragment>
                  )
                }
              }
            />
          </Paper>
        </Grid>
        {
          id != 'new' && (
            <Grid item xs={6}>
              <Paper className={ classes.paper }>
                <QuoteSummary
                  quote={ quote }
                  client={ client }
                  project={ project }
                />
              </Paper>
            </Grid>
          )
        }
        
      </Grid>
    </div>
  )
}

export default QuoteDetails